import Loader from 'Common/Loader';
import DataGrid, { Column, Pager, Paging, Scrolling, SearchPanel, Summary, TotalItem } from 'devextreme-react/cjs/data-grid';
import CustomStore from 'devextreme/data/custom_store';
import moment from 'moment';
import React, { lazy, Suspense, useCallback, useMemo, useState } from 'react';
import { Button, Card } from 'react-bootstrap';
import ShowModal from './Shoemodel';
import { getAllSalesEntryListData, getSalesEntryDetailsById } from '../services';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import useHasPermission from 'hooks/useHasPermission';


const SalesEntryList: React.FC = () => {
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [salesData, setSalesData] = useState<any[]>([]);
    const [refreshKey, setRefreshKey] = useState(0);
    const hasPermission = useHasPermission();


    const dataSource = (): any | undefined => {
        return new CustomStore({
            key: "id",
            load: async (loadOptions) => {
                try {
                    const { searchValue, skip, take } = loadOptions;
                    const parameterList = new URLSearchParams();

                    if (typeof skip === 'number') parameterList.append('skip', skip.toString());
                    if (typeof take === 'number') parameterList.append('take', take.toString());


                    const search = JSON.parse(JSON.stringify(loadOptions));
                    for (const [key, value] of Object.entries(search)) {
                        parameterList.append(key, JSON.stringify(value));
                    }

                    if (searchValue) {
                        parameterList.append("search", searchValue);
                    }

                    const response = await getAllSalesEntryListData(parameterList);

                    return response
                } catch (error) {
                    console.error("Data loading error:", error);
                    return { data: [], totalCount: 0 };
                }
            },
        });
    };

    // const dataSource = useMemo(() => {
    //     return new CustomStore({
    //         key: 'id',
    //         load: async (loadOptions) => {
    //             try {
    //                 const search = JSON.parse(JSON.stringify(loadOptions));
    //                 const parameterList = new URLSearchParams();

    //                 for (const [key, value] of Object.entries(search)) {
    //                     if (value !== undefined && value !== null) {
    //                         parameterList.append(key, JSON.stringify(value));
    //                     }
    //                 }

    //                 const response = await getAllSalesEntryListData(parameterList);
    //                 return response
    //             } catch (error) {
    //                 console.error("Data loading error:", error);
    //                 return { data: [], totalCount: 0 };
    //             } finally {
    //                 setLoading(false);
    //             }
    //         }
    //     });
    // }, [refreshKey]);

    const handleShowDetails = async (salesOrderId: string) => {
        try {
            const res = await getSalesEntryDetailsById(salesOrderId);
            setSalesData(res?.data || []);
            setShowModal(true);
        } catch (err) {
            console.error("Failed to fetch sales entry", err);
        }

    }


    // const renderSerialNumber = useCallback((cellData: any) => {
    //     const rowIndex = cellData.rowIndex + 1 + cellData.component.pageIndex() * cellData.component.pageSize();
    //     return <span>{rowIndex}</span>;
    // }, []);

    const renderActionButtons = useCallback((cellData: any) => (
        <div className='d-flex gap-1'>
            <button
                className='btn btn-sm'
                onClick={() => handleShowDetails(cellData.data.id)}
                title='View details'
            >
                <FontAwesomeIcon icon={faEye} title="View details" className="ml-2 " />
            </button>

        </div>
    ), []);

    const reloadDataSource = useCallback(() => {
        setRefreshKey((prev) => prev + 1);
    }, []);

    const formatDateToIST = (utcDateString: string): string => {
        if (!utcDateString) return "";
        // Ensure it's parsed as UTC
        const date = new Date(utcDateString + "Z");
        return new Intl.DateTimeFormat("en-IN", {
            timeZone: "Asia/Kolkata", // Force IST
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true, // 12h format with AM/PM
        })
            .format(date)
            .replace(",", ""); // remove comma for clean look
    };

    return (
        <React.Fragment>
            {loading && <Loader />}

            <div className="page-content">
                <div className="container-fluid">
                    <Card>
                        <Card.Header className='d-flex justify-content-between align-items-center'>
                            <h5 className='m-0'>Sales Entry List</h5>
                        </Card.Header>
                        <Card.Body>
                            {hasPermission('Transaction.Read') &&
                                <DataGrid
                                    dataSource={dataSource()}
                                    remoteOperations={{ groupPaging: true }}
                                    columnAutoWidth={true}
                                    showRowLines={true}
                                    keyExpr="id"
                                    showBorders={true}
                                    onContentReady={(e) => {
                                        const hasData = e.component.totalCount() > 0;
                                        e.component.option("pager.visible", hasData);
                                        e.component.option("paging.visible", hasData);
                                    }}
                                >
                                    <Scrolling
                                        mode='standard'
                                        useNative={true}
                                        scrollByContent={true}
                                        scrollByThumb={true}
                                    />

                                    <Pager
                                        showPageSizeSelector={true}
                                        allowedPageSizes={[10, 25, 50, 100]}
                                        showNavigationButtons={true}
                                        displayMode="full"
                                        showInfo={true}
                                    />
                                    <Summary>
                                        <TotalItem
                                        // column="Sr.No."
                                        // summaryType="count"
                                        // displayFormat="Total : {0}"
                                        />
                                    </Summary>
                                    <Paging defaultPageSize={10} />
                                    <SearchPanel visible width={240} />
                                    <Column

                                        cssClass='text-center'
                                        allowFiltering={false}
                                        dataField="action"
                                        caption="Action"
                                        dataType="string"
                                        cellRender={renderActionButtons}
                                    />
                                    {/* <Column
                                    caption="Sr.No."
                                    dataType="number"
                                    alignment="center"
                                    cellRender={renderSerialNumber}
                                /> */}

                                    <Column
                                        dataField='id'
                                        caption='Id'
                                        allowFiltering={false}
                                        visible={false}
                                        sortOrder='desc'
                                    />

                                    <Column
                                        cssClass='text-center'
                                        allowFiltering={false}
                                        dataField="createdOn"
                                        caption="Created On"
                                        dataType="string"
                                        width={200}
                                        calculateDisplayValue={(rowData) => formatDateToIST(rowData.createdOn)}
                                    />
                                    <Column
                                        cssClass='text-center'
                                        allowFiltering={true}
                                        dataField="storeCode" caption="Store Code" dataType="string" />
                                    <Column
                                        cssClass='text-center'
                                        allowFiltering={true}
                                        dataField="invoiceNo" caption="Invoice No" dataType="string" />
                                    <Column
                                        cssClass='text-center'
                                        allowFiltering={true}
                                        dataField="customerName" caption="Customer Name" dataType="string" />
                                    <Column
                                        cssClass='text-center'
                                        allowFiltering={true}
                                        dataField="mobileNumber" caption="Mobile Number" dataType="number" />
                                    <Column
                                        cssClass='text-center'
                                        allowFiltering={false}
                                        dataField="subAmount" caption="Sub  Amount" dataType="number" format='#,##0.00' />
                                    <Column
                                        cssClass='text-center'
                                        allowFiltering={false}
                                        dataField="cgst" caption="CGST " dataType="number" format='#,##0.00' />
                                    <Column
                                        cssClass='text-center'
                                        allowFiltering={false}
                                        dataField="sgst" caption="SGST " dataType="number" format='#,##0.00' />
                                    <Column
                                        cssClass='text-center'
                                        allowFiltering={false}
                                        dataField="finalSoAmount" caption="Final Amount" dataType="number" format='#,##0.00' />


                                </DataGrid>
                            }

                        </Card.Body>
                    </Card>
                </div>
            </div>


            <ShowModal
                show={showModal}
                onClose={() => setShowModal(false)}
                data={salesData}
            />

        </React.Fragment>
    );
};

export default SalesEntryList;